import * as Yup from 'yup';
import i18n from '../../../../../translations/strings';

export const ValidationCustomerDataSchema = Yup.object({
  first_name: Yup.string().required(i18n.t('common.requiredField')),
  last_name: Yup.string().required(i18n.t('common.requiredField')),
  email: Yup.string()
    .lowercase()
    .required(i18n.t('common.requiredField'))
    .email(i18n.t('common.validEmail')),
  phone_number: Yup.string()
    .min(8, i18n.t('registration.validNumber'))
    .required(i18n.t('common.requiredField')),
});
